var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { margin: "10px", "font-size": "18px" } }, [
    _c("p", [_vm._v("--Debug--")]),
    _vm._v(" "),
    _vm.htmlPing == -1
      ? _c("p", [_vm._v("value 1 : ERROR")])
      : _c("p", [_vm._v("value 1 : " + _vm._s(_vm.htmlPing) + "ms")]),
    _vm._v(" "),
    _vm.nodePing == -1
      ? _c("p", [_vm._v("value 2 : ERROR")])
      : _c("p", [_vm._v("value 2 : " + _vm._s(_vm.nodePing) + "ms")]),
    _vm._v(" "),
    _vm.mysqlPing == -1
      ? _c("p", [_vm._v("value 3 : ERROR")])
      : _c("p", [_vm._v("value 3 : " + _vm._s(_vm.mysqlPing) + "ms")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a15be5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a15be5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Debug.vue
// module id = 486
// module chunks = 0